import React from 'react';
import TotalAmountDisplay from '../Util/TotalAmountDisplay.jsx';
import CurrencySelector from '../currency/CurrencySelector';

/**
 * The summary line above a form's CTA (Paper 4K0-0, 4LA-0, HG0-0): a count on
 * the left ("2 tickets", "1 item") and the running total on the right, over a
 * subtle rule.
 *
 * On the forms without an amount field (sponsorships, events) the currency picker sits right
 * after the total, beside the amount the donor pays (owner call 2026-10-23). `pickerElementID`
 * is the form's element id; the picker renders nothing unless the org offers another currency.
 */
function GiftSummaryRow({ count, singular, plural, amount, elementID, basis, pickerElementID }) {
  return (
    <div className="flex items-center justify-between border-t border-[color:var(--cs-border-control-subtle)] pt-[var(--cs-space-3)]">
      <span className="font-sans text-[length:var(--cs-text-sm)] leading-[var(--cs-leading-20)] font-normal text-[color:var(--cs-text-secondary)]">
        {count} {count === 1 ? singular : plural}
      </span>
      <span className="inline-flex items-center gap-[var(--cs-space-2)]">
        <TotalAmountDisplay
          amount={amount}
          basis={basis}
          elementID={elementID}
          className="font-sans text-[length:var(--cs-text-sm-plus)] leading-[var(--cs-leading-22)] font-semibold text-[color:var(--cs-text-primary)] tabular-nums"
        />
        {pickerElementID && <CurrencySelector elementID={pickerElementID} />}
      </span>
    </div>
  );
}

export default GiftSummaryRow;
